import angular from 'angular';
import uiRouter from 'angular-ui-router';
import registriesComponent from './registries.component';
import dataTable from 'angular-material-data-table';

let registriesModule = angular.module('registries', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('registries', {
        url: '/registries',
        component: 'registries',
        parent: 'main',
        data: {
            permissions: {
                only: ['ADMIN'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('registries', registriesComponent)
.name;

export default registriesModule;
